<ng-container [formGroup]="parent">
  <ng-container formGroupName="vendor">
    <h3 class="mb-2">Sourcing Vendor</h3>
    <div class="row">
      <div class="col mb-2 vendor-dropdown">
        <div class="form-group has-float-label">
          <label class="form-label">Direct Delivery Vendor</label>
          <input
            pInputText
            #mydropVendor
            jniAutoCompleteBlocker
            type="text"
            id="vendoraccount"
            name="vendoraccount"
            class="form-control"
            [value]="vendorAccountNumber"
            formControlName="duplicateVendorDirectDelivery"
            (input)="searchVendor$.next($any($event.target).value)"
            (keyup)="
              onVendorSearchOpenToggle(PopoverVendorQuote, $event, mydropVendor)
            "
            [ngClass]="{
              'has-error': formErrors['duplicateVendorDirectDelivery'],
            }"
            (blur)="logValidationErrors()" />

          <span
            class="error-msg"
            *ngIf="formErrors['duplicateVendorDirectDelivery']">
            {{ formErrors["duplicateVendorDirectDelivery"] }}
          </span>
        </div>
        <p-popover class="order-dropdown" #PopoverVendorQuote>
          <div class="indropdowntable" style="height: 200px">
            <p-table
              #dt
              [value]="vendorList"
              styleClass="p-datatable-customers order-listing"
              [rowHover]="true"
              [rows]="10"
              [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10, 25, 50]"
              [paginator]="false"
              [filterDelay]="0">
              <ng-template pTemplate="header">
                <tr>
                  <th class="name">Name</th>
                  <th class="vaccount">Vendor Account</th>
                  <th class="sname">Search name</th>
                  <th class="phone">Phone</th>
                  <th class="city">City</th>
                  <th class="state">State</th>
                  <th class="country" style="width: 100px">Country</th>
                </tr>
              </ng-template>
              <ng-template
                pTemplate="body"
                let-vendorList
                let-rowIndex="rowIndex">
                <tr
                  class="p-selectable-row mousepointer"
                  (click)="
                    onVendorRowSelection(vendorList, PopoverVendorQuote)
                  ">
                  <td class="name mousepointer">
                    {{ vendorList.vendorName }}
                  </td>
                  <td class="vaccount mousepointer">
                    {{ vendorList.vendorAccountNumber }}
                  </td>
                  <td class="sname mousepointer">
                    {{ vendorList.vendorSearchName }}
                  </td>
                  <td class="phone mousepointer">
                    {{ vendorList.phoneNumber }}
                  </td>
                  <td class="city mousepointer">{{ vendorList.city }}</td>
                  <td class="state mousepointer">{{ vendorList.state }}</td>
                  <td class="country mousepointer">
                    {{ vendorList.country }}
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="20">No vendor found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-popover>
      </div>
      <div class="col mb-2">
        <div class="form-group has-float-label">
          <label class="form-label"
            >Po Assigment <span class="madatory-field">*</span></label
          >
          <p-select
            [(ngModel)]="poAssignment"
            formControlName="vendorPoAssignment"
            [ngClass]="{
              'has-error': formErrors['vendorPoAssignment'],
            }"
            (blur)="logValidationErrors()"
            [options]="poAssigment"
            optionDisabled="status"
            optionLabel="name"
            optionValue="name"
            [filter]="true"
            [showClear]="true">
          </p-select>

          <span class="error-msg" *ngIf="formErrors['vendorPoAssignment']">
            {{ formErrors["vendorPoAssignment"] }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="form-group has-float-label mb-2"
      (click)="redirectToVendorSummary()">
      <label class="form-label">Vendor name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control has-link"
        placeholder=""
        formControlName="vendorName" />
    </div>
    <div class="form-group has-float-label mb-2">
      <label class="form-label">Vendor address</label>
      <textarea
        pInputText
        jniAutoCompleteBlocker
        class="form-control vendor-address"
        placeholder=""
        formControlName="vendorAddress"></textarea>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group has-float-label mb-2">
          <label class="form-label">Phone number</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="tel"
            class="form-control"
            placeholder=""
            formControlName="vendorPhone" />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group has-float-label mb-2">
          <label class="form-label">Fax</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            type="tel"
            class="form-control"
            placeholder=""
            formControlName="vendorFax" />
        </div>
      </div>
    </div>
    <div class="form-group has-float-label">
      <label class="form-label">Email Address</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="email"
        class="form-control"
        placeholder=""
        formControlName="vendorEmail" />
    </div>
  </ng-container>
</ng-container>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"></jni-vendor-summary>
  </div>
</jni-modal-stacker>
